import { Button, EButtonColor, HeroSection, Section, SectionSubtitle, SectionTitle } from '@web_opxp/components';
import { ETagType, renderMultilineLoca, renderStringToReact, useTranslation } from '@web_opxp/language';
import { useEffect } from 'react';
import ENV from '../../base/env';
import './BridgePopup.scss';

interface IBridgePopupProps {
  show: boolean;
  onBackClick: () => void;
  onOKClick: () => void;
}

export default function BridgePopup({ show, onBackClick, onOKClick }: Readonly<IBridgePopupProps>) {
  const { t } = useTranslation();
  useEffect(() => {
    const postfixClass = ' bridge-active';
    const currentClass = document.body.className;
    let resultClass = '';
    if (show) {
      resultClass = currentClass.endsWith(postfixClass) ? currentClass : currentClass + postfixClass;
    } else {
      resultClass = currentClass.endsWith(postfixClass) ? currentClass.slice(0, -postfixClass.length) : currentClass;
    }
    document.body.className = resultClass;
  }, [show]);
  if (!show) {
    return null;
  }
  const imageSrc = `${ENV.AssetsBaseUrl}/feature/med-awareness/web_med_prescription_illustration.png`;
  const title = t('MedAwareness.Bridge.Title');
  const subtitle = t('MedAwareness.Bridge.Subtitle');
  const subtitleContainsParagraph = subtitle?.startsWith('<p>');
  const sectionSubtitle = subtitle ? <SectionSubtitle>{subtitle}</SectionSubtitle> : null;
  const htmlSectionSubtitle = (
    <SectionSubtitle wrapperTag="div">{renderStringToReact(subtitle, ETagType.div)}</SectionSubtitle>
  );
  const dialogContent = renderMultilineLoca(t('MedAwareness.Bridge.ContentLines'));
  const learnMoreLabel = t('MedAwareness.Bridge.LearnMore');
  const backButtonLabel = t('MedAwareness.Bridge.Back');
  return (
    <div className="bridge-popup">
      <HeroSection imgSrc={imageSrc} className="bridge-hero-section">
        <SectionTitle>{title}</SectionTitle>
        {subtitleContainsParagraph ? htmlSectionSubtitle : sectionSubtitle}
        <div className="buttons-container">
          <Button
            color={EButtonColor.white}
            label={learnMoreLabel}
            className="bridge-button"
            type="button"
            onClick={onOKClick}
          />
          <Button
            color={EButtonColor.white}
            label={backButtonLabel}
            className="bridge-button"
            type="button"
            onClick={onBackClick}
          />
        </div>
      </HeroSection>
      <Section>
        <div className="row">
          <div className="col-6 bridge-content">{dialogContent}</div>
          <div className="col-6" />
        </div>
      </Section>
    </div>
  );
}
